import { Button, InputAdornment, MenuItem, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ReactCodeInput from "react-code-input";
import {
  DIALING_CODES,
  INPUTS_PROPS,
  VERIFICATION_TYPE,
} from "../../../../enums/Enums";
import Icons from "../../../../resources/icons/Icons";
import Strings from "../../../../resources/Strings";
import classes from "../CustomInputs.module.css";
import CustomTimer from "../../Timer/CustomTimer";
import {
  VERIFICATION_CODE_DIGITS,
  VERIFICATION_TIMER,
  DEFAULT_DIALING_CODE
} from "../../../../constants/Constants";
import * as actionsService from "../../../../services/ActionsService/ActionsService";
import { VerificationCodeEntity } from "../../../../entities/ServicesEntities/VerificationsEntities/VerificationCodeEntity";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { fixIsraeliPhoneNumber, removePhoneNumberPrefix, getPhoneNumberDialingCodePrefix, phoneNumberToSend } from "../../../../utils/CommonUtils";
import { useSelector } from "react-redux";
import { isPhoneNumber, isRequired, isSameUserPhoneNumberError } from "../../../../utils/FormUtils";

const VerificationPhoneInput = (props) => {
  const [showVerificationMessage, setShowVerificationMessage] = useState(false);
  const [dialingCode, setDialingCode] = useState(props.isEditMode || props.fromGmt || props.handleVerify ? props.dialingCode : DEFAULT_DIALING_CODE);
  const [isTimeExpired, setIsTimeExpired] = useState(false);
  const [isFirstTimeExpired, setIsFirstTimeExpired] = useState(false);
  const [isVerifiy, setIsVerifiy] = useState(props.isPhoneVerified);
  const [isVerificationClicked, setIsVerificationClicked] = useState(false);
  const [exsistingUserIdentity, setExsistingUserIdentity] = useState("");
  const [verifiyErrorMessage, setVerifiyErrorMessage] = useState(null);
  const parkers = useSelector((state) => state.user?.parkers);
  const [isSameUserPhoneVerifiy, setIsSameUserPhoneVerifiy] = useState(true);

  const [phoneNumberError, setPhoneNumberError] = useState({ errorMessage: "", isValid: "" });
  const reactCodeInputRef = useRef();

  // TODO: add condition to check with currentGmtUsers when fromGmt is selected
  const currentGmtUsers = useSelector((state) => state.user?.currentGmtUsers);

  const timer = useRef();

  const handleClose = () => {
    setIsTimeExpired(false);
    setIsFirstTimeExpired(false);
    setVerifiyErrorMessage("");
    setShowVerificationMessage(false);
  };

  const handleDialingCodeChange = (event) => {
    // on add parker form data / parking allocation
    if (props.dialingCode) {
      // set dialing code in formData and clear phone input
      props.onChange({ 
        [INPUTS_PROPS.DIALING_CODE]: event.target.value,
        [INPUTS_PROPS.PHONE_NUMBER]: ""
      });
    }


    setDialingCode(event.target.value);
  };

  useEffect(() => {
    if(props.hasError && props.isStepSubmitted){
      validatePhoneNumber()
    }
  }, [props.isStepSubmitted]);

  useEffect(() => {
    if (props.handleError) {
      setIsVerificationClicked(false);
      props.onChange({ [props.phoneVerifiedId]: isVerifiy });
      props.handleError({
        [props.id]: props.hasError,
        [props.phoneVerifiedId]: !isVerifiy,
      });
    }
  }, [props.value, isVerifiy]);

  const validatePhoneNumber = () => {
    let fixedPhone = dialingCode + phoneNumberToSend(dialingCode, props.value);
    let isRequiredRes = isRequired(props.value);
    let phoneNumberError;
    let isExistingPhoneValid = props.existingPhoneNumberValidation ? props.existingPhoneNumberValidation() : true;

    if(!isRequiredRes.isValid){
      phoneNumberError = isRequiredRes;
    }else if (!isExistingPhoneValid){
      phoneNumberError = isSameUserPhoneNumberError()
      setIsSameUserPhoneVerifiy(phoneNumberError?.isValid)
    }
    else{
      phoneNumberError = isPhoneNumber(fixedPhone);
    } 
    setPhoneNumberError(phoneNumberError);
    return phoneNumberError?.isValid;
  };

  const sendVerificationCode = () => {
    //TEST - Verify without VerificationCode 
    // setIsVerifiy(true);
    // setVerifiyErrorMessage("");
    // setShowVerificationMessage(false);

    setIsVerificationClicked(true);
    // when phone number not valid
    if (!validatePhoneNumber()) {
      return;
    }

    if (!props.hasError) {
      let fullPhoneNumber = props.value;
      if (!fullPhoneNumber.startsWith(dialingCode)) {
        fullPhoneNumber = dialingCode + fullPhoneNumber;
      }
      var fixedFullPhoneNumber =
        dialingCode === DIALING_CODES.IL
          ? fixIsraeliPhoneNumber(fullPhoneNumber)
          : fullPhoneNumber;

      const verificationCodeEntity = new VerificationCodeEntity(
        "",
        fixedFullPhoneNumber,
        VERIFICATION_TYPE.MOBILE
      );

      //let isParkerFounded = parkers.find(parker => parker.phoneNumber === fixedFullPhoneNumber);

      //let sites = props.site.selectedSites;
      let siteIds = props.isGmtUserCreation ? props.selectedSitesIds : props.selectedSites.map(site => site.id); // site => site.selectedSites.id
      validExsistingUser(fixedFullPhoneNumber).then(response => {
        if(response){
          actionsService.validateAllowedNewParkerSites(fixedFullPhoneNumber, siteIds, props.fromGmt)
          .then((response) => {
          if (response.data.isSuccess) {
            let isParkingFacilitiesFounded = response.data.entity && response.data.entity.length > 0;
            // new parker + facilities is empty
            if (isParkingFacilitiesFounded || props.isGmtUserCreation || props.isAddAllocationProcess) {
              let selectedSitesToUpdate = isParkingFacilitiesFounded ? props.selectedSites?.filter(site => response.data.entity.includes(site.id)) : props.selectedSites;
              // props.selectedSites.filter(site => response.data.entity === site.id) // props.selectedSites.filter(site => response.data.entity.contains(site.id))

              if(isParkingFacilitiesFounded ){
                props.onChange({ ["selectedSites"]: selectedSitesToUpdate });
              } else if(props.isGmtUserCreation){
                let selectedSitesIdsToUpdate = isParkingFacilitiesFounded ? props.selectedSitesIds?.filter(siteId => response.data.entity.includes(siteId)) : props.selectedSitesIds;
                props.onChange({ ["selectedSitesIds"]: selectedSitesIdsToUpdate });
              }

              // when called from existing parking allocation
              if (props.handleVerify) {
                actionsService.validateIsUserExistsInUserSites(fixedFullPhoneNumber, [props.selectedSiteId])
                .then((response) => {
                  if (response.data.isSuccess) {
                    if (response?.data?.entity.length > 0) {
                      // user exists in user site - then send code
                      actionsService
                      .sendVerificationCode(verificationCodeEntity)
                      .then((response) => {
                        if (response.data.isSuccess) {
                          setExsistingUserIdentity(response.data.entity);
                          setShowVerificationMessage(true);
                          timer?.current?.start();
                        }
                      });
                    } else {
                        props.handleVerify(Strings.INPUT_ERROR_MESSAGES.GMT_USER_NOT_FOUND);
                    }
                  }
                })
                .catch((error) => {
                  console.log(error);
                })
              }
              
              // Test after verify
              // setIsVerifiy(true);
              // setVerifiyErrorMessage("");
              // setShowVerificationMessage(false);

              // with timer
              // validates when called from existing parking allocation - code won't be sent twice
              if (!props.handleVerify) { 
                actionsService
                .sendVerificationCode(verificationCodeEntity)
                .then((response) => {
                  if (response.data.isSuccess) {
                    setExsistingUserIdentity(response.data.entity);
                    setShowVerificationMessage(true);
                    timer?.current?.start();
                  }
                });
              }
              

            } else {
              setIsVerifiy(false);
              setVerifiyErrorMessage("Parker already exists");
            }
          } else {
            // error message from response
            setIsVerifiy(false);
            setVerifiyErrorMessage(response.data?.error?.errorTitle);
          }
        });

      // if parker not founded and 'new parker' selected

      // if ((!isParkerFounded && !props.fromGmt) || (isParkerFounded && props.fromGmt)) {
      //   validExsistingUser(fixedFullPhoneNumber).then((isValidExsistingUser) => {
      //     if (
      //       isValidExsistingUser &&
      //       (!showVerificationMessage || timer.current.isCompleted())
      //     ) {
      //       actionsService
      //         .sendVerificationCode(verificationCodeEntity)
      //         .then((response) => {
      //           if (response.data.isSuccess) {
      //             setExsistingUserIdentity(response.data.entity);
      //             setShowVerificationMessage(true);
      //             timer?.current?.start();
      //           }
      //         });
      //     }
      //     if (!isValidExsistingUser) {
      //       setIsVerifiy(false);
      //       setVerifiyErrorMessage("User dosent exsist");
      //     }
      //   });
      // } else if (!isParkerFounded && props.fromGmt) {
      //   setIsVerifiy(false);
      //   setVerifiyErrorMessage("User dosent exsist");
      // }
      //  else {
      //   setIsVerifiy(false);
      //   setVerifiyErrorMessage("User already exists");
      // }
        }else {
          setIsVerifiy(false);
          
          // when called from existing parking allocation
          if (props.handleVerify) {
            props.handleVerify(Strings.INPUT_ERROR_MESSAGES.GMT_USER_NOT_FOUND);
          }
          setVerifiyErrorMessage(Strings.INPUT_ERROR_MESSAGES.USER_NOT_FOUND);
        }
      });   
    }
  };

  // added
  const sendCode = () => {
    // clears the verification code digits
    reactCodeInputRef.current.state.input = reactCodeInputRef.current.state.input.map(d => d = '');
    reactCodeInputRef.current.state.value = "";

    setIsTimeExpired(false);
    setIsFirstTimeExpired(false);
    setVerifiyErrorMessage("");

    // when phone number not valid
    if (!validatePhoneNumber()) {
      return;
    }

    let fullPhoneNumber = props.value;
    if (!fullPhoneNumber.startsWith(dialingCode)) {
      fullPhoneNumber = dialingCode + fullPhoneNumber;
    }
    var fixedFullPhoneNumber =
      dialingCode === DIALING_CODES.IL
        ? fixIsraeliPhoneNumber(fullPhoneNumber)
        : fullPhoneNumber;

    const verificationCodeEntity = new VerificationCodeEntity(
      "",
      fixedFullPhoneNumber,
      VERIFICATION_TYPE.MOBILE
    );

    actionsService
      .sendVerificationCode(verificationCodeEntity)
      .then((response) => {
        if (response.data.isSuccess) {
          setExsistingUserIdentity(response.data.entity);
          setShowVerificationMessage(true);
          timer?.current?.start();
        }
      });
  };

  const verifyCode = (event) => {
    if (
      event.length === VERIFICATION_CODE_DIGITS &&
      !timer.current.isCompleted()
    ) {
      let fullPhoneNumber = props.value;
      if (!fullPhoneNumber.startsWith(dialingCode)) {
        fullPhoneNumber = dialingCode + fullPhoneNumber;
      }
      var fixedFullPhoneNumber =
        dialingCode === DIALING_CODES.IL
          ? fixIsraeliPhoneNumber(fullPhoneNumber)
          : fullPhoneNumber;
      const verificationCodeEntity = new VerificationCodeEntity(
        exsistingUserIdentity,
        fixedFullPhoneNumber,
        VERIFICATION_TYPE.MOBILE,
        event
      );

      actionsService.verifyCode(verificationCodeEntity).then((response) => {
        if (response.data.isSuccess) {
          setIsVerifiy(true);
          setVerifiyErrorMessage("");
          setShowVerificationMessage(false);
          updateUserData(response.data.entity?.userEntity);
          if (props.handleVerify) {
            props.handleVerify(response.data.entity?.userEntity);
          }
        } else {
          setIsVerifiy(false);
          setVerifiyErrorMessage(Strings.INPUT_ERROR_MESSAGES.CODE_VERIFY_FAILURE);
        }
      });
    }
  };

  const handleChange = (event) => {
    setVerifiyErrorMessage("");
    const { name, value } = event.target ? event.target : event;
    let newPhone = value;
    if (props.originalPhoneNumber && props.originalPhoneNumber === value) {
      setIsVerifiy(true);
    } else if (value !== props.value) {
      /*if (!value.startsWith(dialingCode)) {
        newPhone = dialingCode + value;
      }
      setIsVerifiy(false);
      setShowVerificationMessage(false);
      var fixedFullPhoneNumber =
        dialingCode === DIALING_CODES.IL
          ? fixIsraeliPhoneNumber(newPhone)
          : newPhone;*/
      var fixedFullPhoneNumber = newPhone; // added
      setIsVerifiy(false);
      setShowVerificationMessage(false);
    }
    props.onChange({ [name]: fixedFullPhoneNumber });
  };

  const resendCodeAndRenderTimer = () => {
    setVerifiyErrorMessage("");
    sendVerificationCode();
  };

  const handleTimeCompleted = () => {
    setIsTimeExpired(true);
    setIsVerifiy(false);

    // set time expired message only on first time
    if (isTimeExpired && !isFirstTimeExpired) {
      setVerifiyErrorMessage(Strings.INPUT_ERROR_MESSAGES.CODE_TIME_EXPIRED);
      setIsFirstTimeExpired(true);
    }
  };

  const getHelperText = () => {
    let isExistingPhoneValid = props.existingPhoneNumberValidation ? props.existingPhoneNumberValidation() : true;
    if ((props.isStepSubmitted || isVerificationClicked) && props.hasError) {
      return props.errorMessage;
    }
    if (props.isStepSubmitted && !props.isPhoneVerified) {
      return Strings.INPUT_ERROR_MESSAGES.PHONE_NOT_VERIFIED;
    }
    if ((props.isStepSubmitted || isVerificationClicked) && !isExistingPhoneValid) /*props.isStepSubmitted && !isExistingPhoneValid*/ {
      return Strings.INPUT_ERROR_MESSAGES.INVALID_SAME_PHONE; /*phoneNumberError?.errorMessage*/
    }
    // if(!isSameUserPhoneVerifiy){
    //   return phoneNumberError?.errorMessage
    // }
  };

  const hasError = () => {
    let isExistingPhoneValid = props.existingPhoneNumberValidation ? props.existingPhoneNumberValidation() : true;
    return (
      ((props.isStepSubmitted || isVerificationClicked) && props.hasError) ||
      (props.isStepSubmitted && !props.isPhoneVerified) || 
      ((props.isStepSubmitted || isVerificationClicked) && !isExistingPhoneValid) /*(!isSameUserPhoneVerifiy)*/
    );
  };

  const updateUserData = (userEntity) => {
    let utronUser = userEntity?.utronUser;
    let userIdentity = userEntity?.userIdentity;
    if (utronUser&&userIdentity) {
      let newObjData = {
        //[INPUTS_PROPS.FROM_GMT]: false,
        [INPUTS_PROPS.IS_GMT_USER]: true,
        [INPUTS_PROPS.EXSIST_USER]: utronUser,
        [INPUTS_PROPS.PHONE_VERIFIED]: true,
        [INPUTS_PROPS.DIALING_CODE]: getPhoneNumberDialingCodePrefix(userEntity?.userIdentity.phoneNumber),
        [INPUTS_PROPS.FIRST_NAME]: utronUser.firstName,
        [INPUTS_PROPS.LAST_NAME]: utronUser.lastName,
        [INPUTS_PROPS.PROFILE_PICTURE]: utronUser.image,
        [INPUTS_PROPS.EMAIL]: userIdentity.email,
        [INPUTS_PROPS.EXSIST_USER_IDENTITY]: userIdentity,
      };
      let additionalData = utronUser.userAdditionalData;
      if(additionalData && additionalData[0]){
        let kioskLoginName = additionalData[0].kioskLoginName;
        let kioskPIN = additionalData[0].kioskPIN;
        let isAcceptedMobileTermsAndPolicies = additionalData[0].isAcceptedMobileTermsAndPolicies;
        let notes = additionalData[0].notes;

        if(kioskLoginName &&  kioskLoginName !== null){
          newObjData[INPUTS_PROPS.PERSIONAL_ID] = kioskLoginName;
        }
        if(kioskPIN &&  kioskPIN !== null){
          newObjData[INPUTS_PROPS.PERSIONAL_PIN] = kioskPIN;
        } 
        if(isAcceptedMobileTermsAndPolicies && isAcceptedMobileTermsAndPolicies !== null){
          newObjData[INPUTS_PROPS.IS_ACCEPTED_MOBILE_TERMS_AND_POLICIES] = isAcceptedMobileTermsAndPolicies;
        } 
        if(notes && notes !== null) {
          newObjData[INPUTS_PROPS.NOTES] = notes;
        }
      }
      props.onChange(newObjData);
    }
  };

  const validExsistingUser = (phoneNumber) => {
    return new Promise((resolve, reject) => {
      if (props.validateExsistingUser) {
        actionsService.validatePhoneNumber(phoneNumber).then((response) => {
          setIsVerificationClicked(false);
          if (response.data.isSuccess) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      } else {
        resolve(true);
      }
    });
  };

  return (
    <div className={classes.customTextField}>
      <TextField
        disabled={props.disabled}
        fullWidth
        label={props.label}
        id={props.id}
        name={props.id}
        className={classes.textField}
        defaultValue={removePhoneNumberPrefix(props.value)}
        value={props.value} // added value instead defaultValue
        onChange={handleChange}
        error={hasError()} // !phoneNumberError?.isValid && phoneNumberError?.errorMessage ? true : false
        helperText={getHelperText()} // !phoneNumberError?.isValid ? phoneNumberError?.errorMessage : ""
        InputLabelProps={{ shrink: true }}
        InputProps={{
          classes: {
            notchedOutline: classes.filed,
          },
          endAdornment: (
            <span className={[classes.endAdornment, classes.verifyEndAdornment].join(' ')}>
              {!showVerificationMessage && !props.isPhoneVerified && (
                <Button
                  className={classes.inputButton}
                  onClick={sendVerificationCode}
                >
                  {props.actionText}
                </Button>
              )}
              {props.isPhoneVerified && (
                <Button className={classes.inputButton}>
                  <CheckCircleOutlineOutlinedIcon color="success" />
                </Button>
              )}
            </span>
          ),
          startAdornment: (
            <InputAdornment position="start">
              <TextField
                id="outlined-select-currency"
                select
                value={dialingCode}
                onChange={handleDialingCodeChange}
                InputProps={{
                  classes: { notchedOutline: classes.dialingCode },
                }}
                disabled={props.disabled}
              >
                <MenuItem
                  key={DIALING_CODES.US.toString()}
                  value={DIALING_CODES.US}
                >
                  <img src={Icons.USA_FLAG} />
                </MenuItem>
                <MenuItem
                  key={DIALING_CODES.IL.toString()}
                  value={DIALING_CODES.IL}
                >
                  <img src={Icons.ISRAEL_FLAG} />
                </MenuItem>
              </TextField>
              +{dialingCode}
            </InputAdornment>
          ),
        }}
        FormHelperTextProps={{
          classes: {
            error: classes.error,
          },
        }}
      />
      {showVerificationMessage && (
        <div className={classes.codeVerification}>
          <span className={classes.verificationMessage}>
            {Strings.SENFING_VERIFICATION_CODE}
          </span>
          <ReactCodeInput
            className={classes.rootCodeInput}
            type="number"
            fields={6}
            onChange={verifyCode}
            ref={reactCodeInputRef}
          />
          <div className={classes.action}>
            <Button className={isFirstTimeExpired ? classes.cancelButton : classes.formButton} onClick={verifyCode}>
              {Strings.CONFIRM}
            </Button>
            <Button className={classes.cancelButton} onClick={handleClose}>
              {Strings.CANCEL}
            </Button>
            <CustomTimer
              delay={VERIFICATION_TIMER}
              resendCodeAndRenderTimer={resendCodeAndRenderTimer}
              sendCode={sendCode} // added
              timer={timer}
              handleTimeCompleted={handleTimeCompleted}
            />
          </div>
        </div>
      )}
      {!isVerifiy && <div className={classes.error}>{verifiyErrorMessage}</div>}
    </div>
  );
};

export default VerificationPhoneInput;
